import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import {
    AtualizarTipoPesoAtendimentoController,
    CadastrarTipoPesoAtendimentoController,
} from "../../../../../../../Controllers/Geral/GestaoDeCadastros/TipoPesoAtendimento/TipoPesoAtedimentoControllers";
import { ITipoPesoAtendimento } from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/TipoPesoAtendimento/TipoPesoAtendimentoInterfaces";
import IconSelector from "../../../../../../CardsPages/Forms/IconSelector";
import UnForm from "../../../../../../Form";
import { ListarModulosController } from "../../../../../../../Controllers/Geral/Documentos/DocumentosController";

interface ICreateUpdateTipoPesoAtendimentoProps {
    pesoAtendimento?: ITipoPesoAtendimento;
    onSave?: () => void;
}

export default function CreateUpdateTipoPesoAtendimento(
    props: ICreateUpdateTipoPesoAtendimentoProps
) {
    const [icon, setIcon] = useState(
        props.pesoAtendimento?.DS_ICON_PESO_ATENDIMENTO ?? ""
    );

    function CreateUpdateTipoPesoFormSubmit(formData: ITipoPesoAtendimento) {
        let promise: Promise<void>;
        if (props.pesoAtendimento) {
            promise = AtualizarTipoPesoAtendimentoController({
                ...formData,
                DS_ICON_PESO_ATENDIMENTO: icon,
                ID_TIPO_PESO_ATENDIMENTO:
                    props.pesoAtendimento.ID_TIPO_PESO_ATENDIMENTO,
            });
        } else {
            promise = CadastrarTipoPesoAtendimentoController({
                ...formData,
                DS_ICON_PESO_ATENDIMENTO: icon,
            });
        }

        promise.then(() => {
            props.onSave?.();
        });
    }

    return (
        <div>
            {!props.pesoAtendimento && (
                <h5 className="text-center">
                    Cadastre um tipo de Peso de atendimento
                </h5>
            )}
            <UnForm
                handleSubmit={CreateUpdateTipoPesoFormSubmit}
                className="row"
            >
                <UnForm.Input
                    name="DS_TIPO_PESO_ATENDIMENTO"
                    wrapperClassName="col-12 col-md-9 col-lg-8 my-2"
                    label="Descrição"
                    defaultValue={
                        props.pesoAtendimento?.DS_TIPO_PESO_ATENDIMENTO
                    }
                />

                <div className="col-12 col-md-3 col-lg-2 my-2">
                    <UnForm.Switch
                        name="FL_ALERTA_NOTIFICACAO"
                        color="warning"
                        type="checkbox"
                        label="Dispara Alerta"
                        labelPosition="top"
                        defaultChecked={
                            props.pesoAtendimento?.FL_ALERTA_NOTIFICACAO
                        }
                    />
                </div>
                <UnForm.LazySelect
                    name="ID_TIPO_CASO"
                    label="Módulo"
                    wrapperClassName="col-12 col-md-9 col-lg-8 my-2"
                    controller={ListarModulosController}
                    getDS={(modulo) => modulo.DS_MODULO}
                    getKeyValue={(modulo) => modulo.ID_MODULO}
                    defaultValue={props.pesoAtendimento?.ID_TIPO_CASO}
                >
                    <option></option>
                </UnForm.LazySelect>

                <UnForm.Input
                    name="HX_COR_PESO_ATENDIMENTO"
                    type="color"
                    label="Cor"
                    wrapperClassName="col-12 col-md-3 col-lg-2 my-2"
                    defaultValue={
                        props.pesoAtendimento?.HX_COR_PESO_ATENDIMENTO ??
                        "#000000"
                    }
                />

                <IconSelectorWithFormColor
                    onChange={setIcon}
                    defaultValue={
                        props.pesoAtendimento?.DS_ICON_PESO_ATENDIMENTO
                    }
                    defaultColor={
                        props.pesoAtendimento?.HX_COR_PESO_ATENDIMENTO
                    }
                />

                <UnForm.SubmitButton
                    color={props.pesoAtendimento ? "primary" : "success"}
                    icon={props.pesoAtendimento ? faEdit : faPlus}
                    className="w-100"
                    disabled={!icon}
                >
                    {props.pesoAtendimento ? "Editar" : "Cadastrar"}
                </UnForm.SubmitButton>
            </UnForm>
        </div>
    );
}

function IconSelectorWithFormColor(
    props: Omit<Parameters<typeof IconSelector>["0"], "color"> & {
        defaultColor?: string;
    }
) {
    const { watch } = useFormContext();
    const colorWatcher = watch("HX_COR_PESO_ATENDIMENTO", props.defaultColor);

    return <IconSelector color={colorWatcher} {...props} />;
}
